// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '438d5d9cb10b5b6d32c69d4a42ba9d417a14cfc4';
export const BUILD_NUMBER = '279';
export const BUILD_TIMESTAMP = '2026-10-26T09:08:50.774Z';
